import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import CookieConsent from "@/components/CookieConsent";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Smartphone } from "lucide-react";
import lakeBoat from "@/assets/images/lake-boat.webp";
import { APP_STORE_URL } from "@/lib/constants";

const About = () => {
  return (
    <>
      <SEOHead
        title="Om os | MySabbat"
        description="MySabbat er en dansk platform skabt for unge, der står mellem gymnasiet og næste skridt. Vi samler viden, guides og muligheder ét sted."
        path="/om-os"
      />
      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        
        {/* Hero Section */}
        <section className="relative h-64 md:h-80 overflow-hidden">
          <img 
            src={lakeBoat}
            alt="Eventyr på søen"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 container pb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground">
              Om MySabbat
            </h1>
          </div>
        </section>
        
        <main className="flex-1 container py-12 md:py-16 max-w-4xl">
          <div className="space-y-12">
            {/* Hvem er vi */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                Hvem er vi?
              </h2>
              <div className="prose prose-lg max-w-none">
                <p className="text-muted-foreground leading-relaxed">
                  MySabbat er en dansk platform skabt for unge, der står mellem gymnasiet og næste skridt. 
                  Mange oplever usikkerhed og mangler overblik, når de skal beslutte, hvad de vil bruge 
                  deres sabbatår på. MySabbat samler viden, guides og muligheder ét sted, så det bliver 
                  nemmere at forstå valgene og træffe dem i sit eget tempo.
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Vi er uafhængige og har fokus på at give et ærligt og overskueligt overblik – uden at 
                  presse én bestemt løsning. Uanset om du drømmer om at rejse, arbejde, tage på højskole 
                  eller bare har brug for tid til at finde ud af, hvad du vil, er MySabbat her for at hjælpe dig.
                </p>
              </div>
            </section>

            {/* Vores vision */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                Vores vision
              </h2>
              <div className="prose prose-lg max-w-none">
                <p className="text-muted-foreground leading-relaxed">
                  Vores vision er at gøre sabbatåret mere trygt og overskueligt for unge. Vi vil give ro 
                  i maven før valget ved at samle information om rejse, job, højskole, frivilligt arbejde, 
                  økonomi og studievalg på en enkel og forståelig måde.
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  MySabbat skal være et sted, hvor unge kan blive klogere på deres muligheder og finde 
                  den vej, der passer bedst til dem. Vi tror på, at et godt sabbatår starter med god 
                  forberedelse – og det er præcis det, vi hjælper med.
                </p>
              </div>
            </section>

            {/* CTA Section */}
            <section className="bg-muted/50 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                Kom i gang med dit sabbatår
              </h2>
              <p className="text-muted-foreground mb-6">
                Udforsk vores artikler og guides, eller download MySabbat-appen
                på App Store og planlæg dit sabbatår direkte fra mobilen.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild variant="default" size="lg">
                  <Link to="/" className="inline-flex items-center gap-2">
                    <BookOpen className="h-5 w-5" />
                    Se alle artikler
                    <ArrowRight className="h-4 w-4" />
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg">
                  <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2">
                    <Smartphone className="h-5 w-5" />
                    Download appen
                    <ArrowRight className="h-4 w-4" />
                  </a>
                </Button>
              </div>
            </section>
          </div>
        </main>

        <Footer />
        <CookieConsent />
      </div>
    </>
  );
};

export default About;
